import i18next from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

export type AppLanguage = 'en' | 'da' | 'nl' | 'de' | 'sv' | 'no' | 'es' | 'it' | 'fr' | 'pl'

export const SUPPORTED_LANGUAGES: ReadonlyArray<{ code: AppLanguage, label: string }> = [
  { code: 'en', label: 'English' },
  { code: 'da', label: 'Dansk' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'no', label: 'Norsk' },
  { code: 'pl', label: 'Polski' },
  { code: 'sv', label: 'Svenska' }
]

const SUPPORTED_LANGUAGE_CODES: ReadonlyArray<AppLanguage> = SUPPORTED_LANGUAGES.map(l => l.code)

export function isAppLanguage (value: string | null | undefined): value is AppLanguage {
  return value != null && (SUPPORTED_LANGUAGE_CODES as ReadonlyArray<string>).includes(value)
}

const LANGUAGE_STORAGE_KEY = 'kitmaker.lang'

function getStoredLanguage (): AppLanguage {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
    if (isAppLanguage(stored)) {
      return stored
    }
  } catch {
    // localStorage unavailable — fall back to default
  }
  return 'en'
}

export function setLanguage (language: AppLanguage) {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
  } catch {
    // localStorage unavailable — language still changes for this session
  }
  i18next.changeLanguage(language)
}

i18next.use(Backend).use(initReactI18next).init({
  debug: false,
  fallbackLng: 'en',
  supportedLngs: SUPPORTED_LANGUAGE_CODES as string[],
  lng: getStoredLanguage()
})

export default i18next
